import { configureStore } from "@reduxjs/toolkit";
import { api } from './api'
import queryParamsSlice from "./slices/queryParamsSlice";
import TreeSlice from "./slices/treeSlice";
import newTemplateSlice from "./slices/newTemplateSlice";
import apiHelpSlice from "./slices/apiHelpSlice";
import userPermissionsSlice from "./slices/userPermissionSlice";

export const store = configureStore({
  reducer: {
    queryParams: queryParamsSlice,
    treeData: TreeSlice,
    newTemplate: newTemplateSlice,
    [api.reducerPath]: api.reducer,
    apiHelpSlice: apiHelpSlice,
    userPermissions: userPermissionsSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});
